import axios from 'axios'

export default {
  login(data) {
    return axios.post(`${process.env.VUE_APP_AUTH_API_URL}login`, data)
  },

  getUserPermission(token) {
    const requestDTO = {
      applicationList: ['SRM'],
    }
    const url =
      process.env.VUE_APP_GET_PERMISSION_API_URL +
      (token ? `?accessToken=${encodeURIComponent(token)}` : '')
    return axios.post(url, requestDTO)
  },

  logout() {
    return axios.post('logout')
  },
}
